
import {Vue, Component, Watch} from 'vue-property-decorator'
import {Table} from 'element-ui'
import {IPaginationData, ItaskOrderSearchItem} from '@/@types/global'
import AddForm from './components/addForm.vue'
import EditForm from './components/editForm.vue'
import CreateStoreForm from '@/components/createStoreForm.vue'
import {bathDownResult, getTelList} from '@/api/seTel'
import {CommonModule} from '@/store/module/common'
import mapFunc from '@/utils/mapFunc'
import {UserModule} from '@/store/module/user'
import {checkAuth} from '@/utils/decorator'

@Component({
	name: 'commonCreate',
	components: {
		AddForm,
		EditForm,
		CreateStoreForm
	}
})
export default class CommonCreate extends Vue {
	isLoading = false
	usWrap = 'area'
	usValue = ''
	title = '上传筛选'
	searchData: ItaskOrderSearchItem = {
		typeId: '',
		key: '',
		date: '',
		status: '',
		pageNum: 1,
		limit: 10
	}
	isEdit = false
	editFormData = {}
	dialogVisible = false
	dialogVindicate = false
	taskOrderList = []
	selectedItems: number[] = []
	// 分页器
	paginationData: IPaginationData = {
		// 表单数据
		currentPage: 1,
		sizes: [10, 30, 50, 100],
		pageSize: 50,
		total: 0
	}
	// 点击新建仓库按钮------
	storeDialogVisible = false

	get userInfo() {
		return UserModule.userInfo
	}

	get handleInit() {
		return CommonModule.isNeedInitData
	}

	get menuId() {
		return CommonModule.menuId
	}

	get subMenuId() {
		return CommonModule.subMenuId
	}

	get SelectedSubItem(): any {
		return CommonModule.selectedSubItem
	}

	getTableRef() {
		return this.$refs.tableRef || {selection: 0} as any
	}

	getLinkUrl(linkUrl: string) {
		if (linkUrl){
			const link = linkUrl.replace(/UserUploads\/\w+\/\d+\-\d+\/\w+_\d+(?:\.txt|-)/, "")
			return link
		}
		return linkUrl
	}


	@Watch('handleInit', {immediate: true})
	handleInitData() {
		if (this.handleInit) {
			this.paginationData.currentPage = 1
			this.initTelList()
			CommonModule.HANDLE_INIT_STORE_DATA(false)
		}
	}

	mounted() {
		this.initTelList()
	}

	//批量下载
	bathDownHandle(item: any) {
		var codes = this.getTableRef().selection.map((item: any) => item.TaskGuid)
		if (codes.length > 10) {
			this.$message.error(this.$t('c.downHandle').toString())
			return
		}
		bathDownResult(codes)
	}

	initTelList() {
		// 如果不存在，那么取用 'line'
		const typeId = localStorage.getItem('subMenuId')
		const params: ItaskOrderSearchItem = {
			platform: this.menuId,
			typeId: +typeId === 999 ? 0 : typeId,
			key: this.searchData.key,
			date: this.searchData.date,
			status: this.searchData.status,
			pageNum: this.paginationData.currentPage,
			limit: this.paginationData.pageSize
		}
		this.isLoading = true
		getTelList(params)
			.then((res: any) => {
				this.taskOrderList = res.data.map((item: any) => {
					return {
						...item,
						status_: mapFunc.formatStatus(item.Status),
						statusClass: mapFunc.formatStatusClass(item.Status)
					}
				})
				this.paginationData.total = res.total
			})
			.catch(err => {
				this.$message.error(err.msg)
			})
			.finally(() => {
				this.isLoading = false
			})
	}

	// 点击搜索
	handleSearch() {
		this.paginationData.currentPage = 1
		this.initTelList()
	}

	// 重置搜索条件
	handleReset() {
		this.searchData.key = ''
		this.searchData.date = ''
		this.searchData.status = ''
		this.searchData.pageNum = 1
		this.searchData.limit = 10
	}

	handleCreateChange(item: any, row: any) {
		switch (item) {
			case 1:
				this.downloadFile(row.TaskGuid, 'export')
				break
			case 2:
				this.downloadFile(row.TaskGuid, 'downOrginFile')
				break
			case 3:
				this.handleEdit(row)
				break
			case 4:
				this.prevFile(row.TaskGuid, 'preview')
				break
			case 5:
				this.downloadFile(row.TaskGuid, 'exportUnreg')
				break
			default:
				console.log(4)
				break
		}
	}

	// 预览文件
	prevFile(id: string, type: string) {
		const preFix = window.location.protocol + '//' + window.location.host
		window.open(`${preFix}/api/taskOrder/${type}?taskGuid=${id}`)
	}

	// handleDelete() {
	//   if (this.selectedItems.length === 1) {
	//   this.$confirm('请再次确认是否删除', '提示', {
	//       confirmButtonText: '确定',
	//       cancelButtonText: '取消',
	//       type: 'warning'
	//     })
	//       .then(() => {
	//         const params = {
	//           code: this.selectedItems[0]
	//         }
	//         deleteStore(params)
	//           .then(() => {
	//             this.$message.success('删除成功')
	//             this.initTableList()
	//           })
	//           .catch((err: any) => {
	//             this.$message.error(err.msg)
	//           })
	//       })
	//       .catch(() => {
	//         this.$message({
	//           type: 'info',
	//           message: '已取消'
	//         })
	//       })
	//   } else {
	//     this.$message.warning('请选择其中一项进行删除')
	//   }
	// }

	// 下载文件
	downloadFile(id: string, type: string) {
		const preFix = window.location.protocol + '//' + window.location.host
		window.open(`${preFix}/api/taskOrder/${type}?taskGuid=${id}`)
	}

	// downloadFile2(id: string, type: string) {
	// 	const preFix = window.location.protocol + '//' + window.location.host
	// 	window.open(`${preFix}/api/taskOrder/${type}?taskGuid=${id}`)
	// }

	// 编辑任务
	@checkAuth(2)
	handleEdit(row: any) {
		if (this.userInfo.roleID === 1 || this.userInfo.roleID === 3) {
			// 只有管理员权限才可以编辑
			this.isEdit = true
			this.dialogVisible = true
			this.title = '修正数据'
			this.editFormData = row
			this.$nextTick(() => {
				const editFormRef = this.$refs.editFormRef as EditForm
				editFormRef.initDialog(row)
			})
		}
	}

	handleSelectionChange(rows: []) {
		this.$nextTick(() => {
			if (rows) {
				this.selectedItems = []
				rows.forEach((row: any) => {
					this.selectedItems.push(row.id)
				})
				this.selectedItems = [...new Set(this.selectedItems)]
			} else {
				if (this.selectedItems.length > 0) {
					const tableRef = this.$refs.tableRef as Table
					tableRef.clearSelection()
					this.taskOrderList.forEach((item: any) => {
						if (this.selectedItems.includes(item.id)) {
							tableRef.toggleRowSelection(item)
						}
					})
				}
			}
		})
	}

	// 点击保存
	@checkAuth(2)
	handleSave() {
		if (this.isEdit) {
			const editFormRef = this.$refs.editFormRef as EditForm
			editFormRef.handleSave()
		} else {
			const addFormRef = this.$refs.addFormRef as AddForm
			addFormRef.handleSave()
		}
	}

	// 新建或编辑成功触发事件
	handleSuccess() {
		this.dialogVisible = false
		this.paginationData.currentPage = 1
		this.initTelList()
	}

	handleSizeChange(val: number) {
		this.paginationData.pageSize = val
		this.initTelList()
	}

	handleCurrentChange(val: number) {
		this.paginationData.currentPage = val
		this.initTelList()
	}

	// 新建筛选--点击新建按钮
	handleClick() {
		console.log(this.SelectedSubItem)
		if (this.SelectedSubItem.CanOrder === 0) {
			this.dialogVindicate = true
			return
		}
		this.isEdit = false
		this.dialogVisible = true
		this.title = '新建筛选'
		this.$nextTick(() => {
			const addFormRef = this.$refs.addFormRef as AddForm
			addFormRef.initDialog()
		})
	}

	handleCreateStore() {
		this.dialogVisible = false
		this.storeDialogVisible = true
	}

	// 提交创建仓库
	handleConfirm() {
		const formRef = this.$refs.CreateStoreFormRef as CreateStoreForm
		formRef.handleConfirm()
	}
}
